import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { aboveHeader5 } from "./assets/images";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const { lang } = useParams();

  const handleLanguageChange = async (event) => {
    const newLang = event.target.value;
    await i18n.changeLanguage(newLang);
    const currentPath = window.location.pathname.replace(/^\/[a-z]{2}/, '');
    navigate(`/${newLang}${currentPath}`);
    window.location.reload(); // Müvəqqəti həll olaraq saxlanılıb
  };

  return (
    <div className="flex items-center ml-4">
      <img className='w-6 h-6' src={aboveHeader5}></img>
      <select
        value={lang || i18n.language}
        onChange={handleLanguageChange}
        className="rounded px-2 py-1"
      >
        <option value="az">AZ</option>
        <option value="en">EN</option>
      </select>
    </div>
  );
};

export default LanguageSwitcher;
